import { ChartDrawOption } from '@/modules/ta/widget/models/drawoptions/ChartDrawOption';
import {
  SankeyLinkFillStyle,
  SankeyMaxNodes,
  SankeyNodeAlign,
  SankeyOrientation,
} from '@/modules/core/charts/am5/sankey/sankey.constants';

export class SankeyChartDrawOption extends ChartDrawOption {
  /**
   * @var {boolean}
   */
  show_labels;

  /**
   * @var {string}
   */
  orientation;

  /**
   * @var {string}
   */
  node_align;

  /**
   * @var {number}
   */
  node_width;

  /**
   * @var {number}
   */
  node_padding;

  /**
   * @var {number}
   */
  link_tension;

  /**
   * @var {number}
   */
  max_nodes;

  /**
   * @var {boolean}
   */
  has_tooltip;

  constructor(model = {}) {
    super(model);

    this.show_labels = model.show_labels ?? true;
    this.orientation = model.orientation ?? SankeyOrientation.HORIZONTAL;
    this.node_align = model.node_align ?? SankeyNodeAlign.LEFT;
    this.link_fill_style = model.link_fill_style ?? SankeyLinkFillStyle.GRADIENT;
    this.node_width = model.node_width ?? 20;
    this.node_padding = model.node_padding ?? 10;
    this.link_tension = model.link_tension ?? 0;
    this.max_nodes = model.max_nodes ?? SankeyMaxNodes.DEFAULT;
    this.has_tooltip = model.has_tooltip ?? true;
  }
}
